import { useCallback } from 'react';
import type { Vector3 as vec3 } from '@kitware/vtk.js/types';
import type { ToolInteractionAnnotationResponse } from 'generated/graphql';
import type { HandleCreateAnnotation } from '../../Toolbox';
import type { Segment } from '../../../Annotations/types';

const OPTIONAL_ANNOTATION_PROPERTIES = [
  'label',
  'groupId',
  'style',
  'allowedTransformations',
  'customLogic',
];

type UseAnnotationResponseArgs = {
  createAnnotation: HandleCreateAnnotation;
  indexToWorld: (arg1: vec3) => vec3 | null | undefined;
};

export function useAnnotationResponse({
  createAnnotation,
  indexToWorld,
}: UseAnnotationResponseArgs): (response: Readonly<ToolInteractionAnnotationResponse>) => unknown {
  const handleAnnotationResponse = useCallback(
    (response: Readonly<ToolInteractionAnnotationResponse>) => {
      const annotation = response.annotation;

      if (annotation == null) return null;

      const optional = OPTIONAL_ANNOTATION_PROPERTIES.reduce<Record<string, any>>((acc, key) => {
        // @ts-expect-error [EN-10263] - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ToolInteractionAnnotationData'.
        if (annotation[key] != null) {
          // @ts-expect-error [EN-10263] - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ToolInteractionAnnotationData'.
          acc[key] = annotation[key];
        }
        return acc;
      }, {});

      return createAnnotation({
        ...optional,
        type: annotation.type,
        segments: annotation.segments.map(
          ({ start, end }) =>
            [
              // @ts-expect-error [EN-7967] - TS2339 - Property 'worldSpace' does not exist on type 'ExtendedCoordinates'. | TS2339 - Property 'indexSpace' does not exist on type 'ExtendedCoordinates'.
              start.worldSpace ?? indexToWorld(start.indexSpace),
              // @ts-expect-error [EN-7967] - TS2339 - Property 'worldSpace' does not exist on type 'ExtendedCoordinates'. | TS2339 - Property 'indexSpace' does not exist on type 'ExtendedCoordinates'.
              end.worldSpace ?? indexToWorld(end.indexSpace),
            ] as Segment
        ),
      });
    },
    [createAnnotation, indexToWorld]
  );

  return handleAnnotationResponse;
}
